import { render, staticRenderFns } from "./vendas.vue?vue&type=template&id=55137526"
import script from "./vendas.ts?vue&type=script&lang=js&external"
export * from "./vendas.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55137526')) {
      api.createRecord('55137526', component.options)
    } else {
      api.reload('55137526', component.options)
    }
    module.hot.accept("./vendas.vue?vue&type=template&id=55137526", function () {
      api.rerender('55137526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/home/fastaction/vendas/vendas.vue"
export default component.exports